import { useEffect, useState } from 'react';

/**
 * Debounce a value. Search boxes talk to the server, not to a client-side
 * filter, so every keystroke would otherwise be a D1 query over 20k rows.
 */
export function useDebounced<T>(value: T, delayMs = 250): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    if (value === settled) return;
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, settled, delayMs]);

  return settled;
}
